// src/admincomponents/SortableItem.js
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function SortableItem({ id, accreditation, onDelete, apiUrl }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="col-sm-6 col-lg-4 col-xl-3">
      <div className="card h-100 border-0 shadow-sm" style={{ borderRadius: 16, overflow: 'hidden' }}>
        <div style={{ position: 'relative' }}>
          <img
            src={`${apiUrl}/${accreditation.imagepath}`}
            alt={accreditation.title}
            style={{ width: '100%', height: 160, objectFit: 'cover' }}
          />
          <span
            className="badge bg-main-600 text-white position-absolute rounded-pill text-13 fw-medium"
            style={{ top: 10, left: 10, padding: '4px 12px' }}
          >
            #{accreditation.position}
          </span>
          <span
            {...attributes}
            {...listeners}
            className="position-absolute bg-white rounded-circle d-flex align-items-center justify-content-center shadow-sm"
            style={{ top: 10, right: 10, width: 32, height: 32, cursor: 'grab' }}
            title="Drag to reorder"
          >
            <i className="ph ph-dots-six-vertical text-gray-500" />
          </span>
        </div>
        <div className="card-body py-12 px-16">
          <span className="fw-semibold text-15 text-truncate d-block mb-10" title={accreditation.title}>
            {accreditation.title}
          </span>
          <button
            type="button"
            className="btn btn-sm rounded-pill py-6 px-16 w-100"
            style={{ backgroundColor: '#dc3545', borderColor: '#dc3545', color: '#fff', opacity: 1 }}
            onClick={() => onDelete(accreditation.id)}
          >
            <i className="ph ph-trash me-1" /> Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default SortableItem;
